import React, { useId } from "react";
import accessibility from "../../accessibility.js";
import tampuuriWindowObject from "../../tampuuriWindowObject.js";
import useHelpers from "../hooks/useHelpers.jsx";
import { PRICE_LEVELS } from "../priceLevels.js";

function SelectPriceLevels(props) {
  const { params, submitParams, svgObjects } = props;
  const { translate } = tampuuriWindowObject();
  const { announceMessage, globalAccessibilitySpeakerId } = accessibility();
  const id = useId();
  const { checkForChecked } = useHelpers();

  const addPriceLevel = (value) => {
    let currentPriceLevels = [...(params?.priceLevels ?? [])];
    let accessibilitySpeakerLabel = "";

    if (checkForChecked(value, currentPriceLevels)) {
      currentPriceLevels = currentPriceLevels.filter((e) => e !== value);
      accessibilitySpeakerLabel = translate("Remove") + " " + translate(value);
    } else {
      currentPriceLevels.push(value);
      accessibilitySpeakerLabel = translate("Add") + " " + translate(value);
    }

    submitParams({ priceLevels: currentPriceLevels, setFirstPage: true });
    announceMessage(globalAccessibilitySpeakerId, accessibilitySpeakerLabel);
  };

  return (
    <div className="price-levels" role="group" aria-labelledby={id}>
      <legend id={id}>{translate("Hintataso")}</legend>
      <div className="filter-buttons-container">
        {PRICE_LEVELS.map((value, index) => {
          return (
            <button
              className={
                checkForChecked(value, params?.priceLevels ?? [])
                  ? "active"
                  : ""
              }
              key={"price_level_" + value + index}
              onClick={(e) => {
                e.preventDefault();
                addPriceLevel(value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  addPriceLevel(value);
                }
              }}
            >
              {translate(value)}{" "}
              {checkForChecked(value, params?.priceLevels ?? []) ? (
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: svgObjects?.close,
                    }}
                  />
                  <span className="sr-only">
                    {translate("Selected") + " " + translate(value)}
                  </span>
                </>
              ) : (
                <span className="plus" aria-hidden="true">
                  +
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default SelectPriceLevels;
